<template>
  <div class="custom-member">
    <i v-if="isnew === 1" class="fas fa-user-plus custom-new"></i>
    <a @click="onClick">
      <img :src="avatar" />
      <span>{{ name }}</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'member-record',
  props: {
    avatar: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: [Number, String],
      default: null,
    },
    isnew: {
      type: [Number, Boolean],
      default: 0,
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked', this.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-member {
  position: relative;
  a {
    text-decoration: none;
    cursor: pointer;
  }
  a:hover {
    outline: none;
    text-decoration: none;
    color: #72afd2;
  }
  img {
    border-radius: 50%;
    float: left;
    width: 40px;
    height: 40px;
  }
  span {
    margin-left: 10px;
    top: 10px;
    position: relative;
  }
}
.custom-new {
  position: absolute;
  top: -5px;
  right: -5px;
  color: #008f4c;
}
</style>
